import styled from "styled-components"


export const ErrorWrapper = styled.div`
  margin-top: 60px;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  h4 {
    font-size: 35px;
    color: #022142;
  }
  p {
    font-size: 14px;
  }
  button {
    max-width: 200px;
    width: 100%;
    padding: 13px 0;
    background: #004ea3;
    border-radius: 4px;
    font-family: "Saira Semi Condensed", sans-serif;
    font-weight: 600;
    border: none;
    color: white;
    margin-top: 25px;
    cursor: pointer;
  }
`;